module.exports = __webpack_public_path__ + "static/media/74-roz-wayland.c81aea59.jpg";